/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import ConfirmAlertWithAmount from 'modules/common/components/ConfirmAlertWithAmount';
import SeniorCitizenContent from './SeniorCitizenContent';
import SeniorCitizenModal from '../modals/SeniorCitizenModal';

import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
  status: '',
  type: 'SENIOR',
};


function SeniorCitizenContainer({
  permissions,
  history,
  match,
  isLoading,

  showSeniorCitizen,
  seniorCitizenList,
  getSeniorCitizenList,
  seniorCitizenListPager,

  approveTransaction,
  rejectTransaction,

}) {
  const setModal = useContext(ModalContext);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {

    getSeniorCitizenList({ type: 'SENIOR' })
  };

  const param = {
    type: 'SENIOR',
    q: formData.keyword,
    sort_by: 'desc',
    status: filter.status,
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      status: e.value,
    });
    getSeniorCitizenList({ ...filter, status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getSeniorCitizenList({ type: 'SENIOR', q: formData.keyword });
    } else {
      getSeniorCitizenList({ type: 'SENIOR' });
    }
  }, [debouncedSearchTerm]);

  // handle Approve button
  const handleApprove = (data) => (e) => {
    e.preventDefault();

    // const args = {
    //   status: 'APPROVED',
    //   amount: '12000',
    //   remarks: 'random test 3',
    // }
    // approveTransaction(
    //   _.get(data, 'id'),
    //   args,
    //   () => {
    //     showSeniorCitizentList(_.get(data, 'id'));
    //   }
    // );

    ConfirmAlertWithAmount(
      'Are you sure, you want to Approve this application?',
      (remarks, amount) => {

        const args = {
          status: 'APPROVED',
          remarks,
          amount,
          type: 'SENIOR',
        }
        approveTransaction(
          _.get(data, 'id'),
          args,
          () => {
            showSeniorCitizentList(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // const aprove = (data) => (e) => {
  //   e.preventDefault();
  //   const args = {
  //     status: 'APPROVED',
  //     amount: '5000.00',
  //     remarks: 'testing'
  //     // module_type: 'SENIOR',
  //   }

  //   approveTransaction(
  //     _.get(data, 'id'),
  //     args,
  //     () => {
  //       showSeniorCitizentList(_.get(data, 'id'));
  //     }
  //   );
  // }

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <SeniorCitizenModal actionType="ADD" />,
      title: 'Add Citizen',
      modalSize: 'modal-lg',
    });
  };

  // handle reject button
  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        rejectTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'REJECTED'
          },
          () => {
            showSeniorCitizen(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const exportCSV = () => {

    const handleExportCsv = e => {
      e.preventDefault();

      const src = `${process.env.REACT_APP_WS
        }/api/v1/administrators/export/social_amelioration_citizens?bearer_token=${token}&email=${_.get(authProfile, 'email')}&type=${param.type}&q=${param.q}&output=D`;

      setTimeout(() => {
        window.location.href = src;
      }, 500);
    }

    return (
      <div className="d-flex align-items-center px-0 pt-2">
        {Acl(permissions, ['SOCIAL AMELIORATION SENIOR EXPORT CSV']) && (
          <button
            onClick={handleExportCsv}
            className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary w-100"
          >
            Export Senior Citizen List to CSV
          </button>
        )}
      </div>
    )
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName=""
            getData={getSeniorCitizenList}
            setParams={param}
            setKeyword={handleOnChange}

            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'status')
            )}
            status={_.get(filter, 'status') || ''}
            keyword={_.get(formData, 'keyword') || ''}

            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            // listName="Transaction"
            label="Citizen Lists"
            // LEFT SECTION
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="senior-citizen-list">
                  {`${_.get(item, 'attributes.first_name') || ''} ${_.get(item, 'attributes.middle_name') || ''} ${_.get(item, 'attributes.last_name') || ''}`}
                </div>
                <h4 className="mt-1 mb-0 senior-citizen-list-numbers">
                  {' '}{_.get(item, 'attributes.contact_number')}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            // statusFilter
            selected={params.id}
            data={seniorCitizenList}
            dataPager={seniorCitizenListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            // RIGHT SECTION
            renderTopContent={() => (
              <div className="w-100 d-flex px-3 pb-3">
                {Acl(permissions, ['SOCIAL AMELIORATION SENIOR ADD']) && (
                  <button
                    type="button"
                    onClick={handleAddModal}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                    style={{ height: "32px" }}
                  >
                    <i className="fas fa-plus" /> &nbsp;&nbsp;
                    Add Senior Citizen
                  </button>
                )}
              </div>
            )}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <SeniorCitizenContent
                        UpdateData={UpdateData}
                        testingApprove={handleApprove}

                        onApprove={handleApprove}
                        onReject={handleReject}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.seniorId && seniorCitizenList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(seniorCitizenList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            customButton={exportCSV()}
          />
        )}
      />
    </div>
  );
}

SeniorCitizenContainer.propTypes = {
  permissions: PropTypes.instanceOf(Array).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,

  seniorCitizenList: PropTypes.instanceOf(Object).isRequired,
  getSeniorCitizenList: PropTypes.instanceOf(Function).isRequired,
  seniorCitizenListPager: PropTypes.instanceOf(Object).isRequired,
  showSeniorCitizen: PropTypes.instanceOf(Function).isRequired,

  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,

  seniorCitizenInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  isLoading: api.loading.indexOf(c.GET_SENIOR_CITIZEN) > -1,

  seniorCitizenList: _.get(api, `${c.GET_SENIOR_CITIZEN}.list`) || [],
  seniorCitizenListPager: _.get(api, `${c.GET_SENIOR_CITIZEN}.pager`) || [],

  // individual info
  seniorCitizenInfo: _.get(api, `${c.SHOW_SENIOR_CITIZEN}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SeniorCitizenContainer);